// extracted by mini-css-extract-plugin
export default {"details":"OBVS0","logs":"mMHsi"};